import React, { Suspense, useState } from 'react';
import { lazyWithRetry } from '../utils/lazyWithRetry';
import PublicFooter from './PublicFooter';

const AboutDialog = lazyWithRetry(() => import('./AboutDialog'));
const ContactDialog = lazyWithRetry(() => import('./ContactDialog'));

export interface AuthenticatedAppFooterProps {
  onNavigateToPricing: () => void;
}

/**
 * Site footer + legal dialogs for logged-in users (mirrors PublicHomePage footer behavior).
 */
const AuthenticatedAppFooter: React.FC<AuthenticatedAppFooterProps> = ({ onNavigateToPricing }) => {
  const [aboutOpen, setAboutOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <>
      <PublicFooter
        onOpenAbout={() => setAboutOpen(true)}
        onOpenContact={() => setContactOpen(true)}
        onOpenPricing={() => {
          window.history.pushState({}, '', `${window.location.pathname}#pricing`);
          window.dispatchEvent(new CustomEvent('navigateToPricing'));
          onNavigateToPricing();
        }}
      />
      <Suspense fallback={null}>
        <AboutDialog open={aboutOpen} onClose={() => setAboutOpen(false)} />
        <ContactDialog open={contactOpen} onClose={() => setContactOpen(false)} />
      </Suspense>
    </>
  );
};

export default AuthenticatedAppFooter;
